import { useState } from 'react'
import './App.scss';
import { BrowserRouter as Router } from "react-router-dom"
import RootRoutes from './routing/routes';
import appContext from "./appContext";
import { sidebarValueConstants } from './pages/Workspace/sidebarutils';
import { optionModeConstants } from './Utils/common';

function App() {
  const [formData, setFormData] = useState<[]>([])
  const [uploadState, setuploadState] = useState<boolean>(false)
  const [addIpOptions, setAddIpOptions] = useState<any>({})
  const [removeIpOptions, setRemoveIpOptions] = useState<any>({})
  const [optionCount, setOptionCount] = useState(1);
  const [auth, setAuth] = useState("");
  const [addChoiceTrigger, setAddChoiceTrigger] = useState<boolean>(false)
  const [selectedMode, setSelectedMode] = useState<string>(sidebarValueConstants.published)
  const [groupsList, setGroupsList] = useState<[]>([])
  const [contactGroup, setContactGroup] = useState<string>("")
  const [isListEmpty, setIsListEmpty] = useState<boolean>(false)
  const [optionMode, setOptionMode] = useState<string>(optionModeConstants.basic)
  const [isListSearchActive, setIsListSearchActive] = useState<boolean>(false)
  const [profileAvatar, setProfileAvatar] = useState<string>("")
  const [openLogicDialog, setOpenLogicDialog] = useState<boolean>(false)
  const [currentFormtitle, setCurrentFormtitle] = useState<string>("");
  const [triggerRemoveLogic, setTriggerRemoveLogic] = useState<boolean>(false)

  const contextItems = {
    formData,
    setFormData,
    uploadState,
    setuploadState,
    addIpOptions,
    setAddIpOptions,
    removeIpOptions,
    setRemoveIpOptions,
    optionCount,
    setOptionCount,
    auth,
    setAuth,
    addChoiceTrigger,
    setAddChoiceTrigger,
    selectedMode,
    setSelectedMode,
    groupsList,
    setGroupsList,
    contactGroup,
    setContactGroup,
    isListEmpty,
    setIsListEmpty,
    isListSearchActive,
    setIsListSearchActive,
    profileAvatar,
    setProfileAvatar,
    optionMode,
    setOptionMode,
    openLogicDialog,
    setOpenLogicDialog,
    currentFormtitle,
    setCurrentFormtitle,
    triggerRemoveLogic,
    setTriggerRemoveLogic
  }

  return (
    <div className="App">
      <appContext.Provider value={contextItems}>
        <Router>
          <RootRoutes />
        </Router>
      </appContext.Provider>
    </div>
  );
}

export default App;
